<section class="ask">
  <div class="container ask-grid">
    <p class="ask-claim">Still looking? <span>Just ask.</span></p>
    <div>
      <form class="ask-search" role="search" (submit)="$event.preventDefault(); search(q.value)">
        <label class="ask-field">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
            <circle cx="10.5" cy="10.5" r="6.5" /><path d="M15.5 15.5 21 21" />
          </svg>
          <span class="visually-hidden">Search products</span>
          <input #q type="search" placeholder="Search in plain English…" autocomplete="off" />
        </label>
        <button class="ask-btn" type="submit">Search</button>
      </form>
      <p class="ask-sugg">Try:
        @for (s of suggestions; track s) {
        <a [routerLink]="['/search']" [queryParams]="{ q: s }">{{ s }}</a>
        }
      </p>
    </div>
  </div>
</section>
